import { Col, Form, Row, Button, Modal, Spinner } from "react-bootstrap";
import "./Notification.css";
import React, { useEffect, useState, useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import Widgets from "../../components/Widgets";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { RxCrossCircled } from "react-icons/rx";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FiPlus } from "react-icons/fi";
import { MdClear } from "react-icons/md";
import { HiOutlinePencil } from "react-icons/hi";
import CustomPagination from "../../components/CustomPagination";
import CircularProgress from "../../components/CircularProgress";
import TableSkeleton from "../../components/table/TableSkeleton";

import {
    getNotificationsPath,
    notifyApproveRequestPath,
} from "../../services/config";

import { fetchData, initShiftState } from "../../redux/slices/shiftsSlice";
import {
    commonGetData,
    commonSaveData,
    initCommonState,
} from "../../redux/slices/commonSlice";
import {
    fetchBranchData,
    initBranchState,
} from "../../redux/slices/branchSlice";

import {
    getUniqueLocations,
    splitWaypoints,
    getSnapToRoadsWayPoints,
    getInitials,
    getInitialColor,
    getCapitalizeWord,
    notificationTitle,
    getTitleBtn,
} from "../../services/commonServices";

import Map from "../../components/Map/NotificationMap";
import { HasPermission } from "../../services/hasPermission";
import { Link, useNavigate } from "react-router-dom";

const Notification = ({ active_tab }) => {
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const commonStore = useSelector((state) => state.common);
    const branchState = useSelector((state) => state.branch);
    const shiftState = useSelector((state) => state.shift);
    const themeStore = useSelector((state) => state.theme);

    const user = JSON.parse(localStorage.getItem("user_data") || "[]");

    const [countLeaves, setCountLeave] = useState({
        Leave: 0,
        Regularization: 0,
        Offsite: 0,
        Permission: 0,
        Other: 0,
    });

    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        const tab =
            active_tab === "leave"
                ? 0
                : active_tab === "offsite"
                    ? 2
                    : active_tab === "regularisation"
                        ? 1
                        : active_tab === "halfDay"
                            ? 3
                            : 0;

        if (activeTab !== tab) {
            handleTabIndex(tab);
        }
    }, [active_tab]);

    const [description, setDescription] = useState([]);
    const [filterDescription, setFilterDescription] = useState([]);
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [waypoints, setWaypoints] = useState([]);
    const [loadingWaypoints, setLoadingWaypoints] = useState(false);
    const [approveStatus, setApproveStatus] = useState({
        notifyId: "",
        staffId: "",
        approve: "",
        reason: "",
    });
    const [branch, setBranch] = useState([]);
    const [shift, setShift] = useState([]);
    const [fullscreen, setFullscreen] = useState(true);

    const [state, setState] = useState({
        userName: "",
        branchId: "",
        shiftId: "",
    });

    const [userData, setUserData] = useState({
        id: "",
        staffId: "",
        wishMessage: "",
        profileImage: "",
        staffName: "",
        employeeId: "",
    });

    const [selectedLeave, setSelectedLeave] = useState({});
    const [gridApi, setGridApi] = useState(null);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    const getData = useCallback(() => {
        dispatch(fetchBranchData(user.user_id));
        dispatch(fetchData(user.user_id));
    }, [dispatch, user.user_id]);

    const getNotification = useCallback(() => {
        const path = `${getNotificationsPath}${user.user_id}`;
        dispatch(commonGetData(path));
    }, [dispatch, user.user_id]);

    useEffect(() => {
        getNotification();
    }, []);

    useEffect(() => {
        if (commonStore.commonGetSuccess) {
            if (activeTab) {
                if (commonStore.commonGetData) {
                    const filtered =
                        activeTab === "4"
                            ? commonStore.commonGetData.leaveRequests.filter(
                                (v) => !["1", "2", "3", "4"].includes(v.referenceId)
                            )
                            : commonStore.commonGetData.leaveRequests.filter(
                                (v) => v.referenceId === (activeTab + 1).toString()
                            );
                    setDescription(filtered);
                }
            } else {
                if (commonStore.commonGetData) {
                    const newArr =
                        commonStore.commonGetData?.leaveRequests?.filter(
                            (v) => v.referenceId === "1"
                        ) || [];
                    setDescription(newArr);

                    const leave =
                        commonStore.commonGetData?.leaveRequests?.filter(
                            (v) => v.referenceId === "1" && v.approved === "0"
                        ) || [];
                    const regularization =
                        commonStore.commonGetData?.leaveRequests?.filter(
                            (v) => v.referenceId === "2"
                        ) || [];
                    const offsite =
                        commonStore.commonGetData?.leaveRequests?.filter(
                            (v) => v.referenceId === "3" && v.approved === "0"
                        ) || [];
                    const permission =
                        commonStore.commonGetData?.leaveRequests?.filter(
                            (v) => v.referenceId === "4" && v.approved === "0"
                        ) || [];
                    const other =
                        commonStore.commonGetData?.leaveRequests?.filter(
                            (v) => !["1", "2", "3", "4"].includes(v.referenceId)
                        ) || [];

                    setCountLeave((pre) => ({
                        ...pre,
                        Leave: leave.length,
                        Regularization: regularization.length,
                        Offsite: offsite.length,
                        Permission: permission.length,
                        Other: other.length,
                    }));

                    getData();
                }

                setFilterDescription(commonStore.commonGetData.leaveRequests);
                dispatch(initCommonState());
            }
        }

        if (branchState.brnGetSuccess) {
            setBranch(branchState.brnGetData);
            dispatch(initBranchState());
        }

        if (shiftState.shiftGetSuccess) {
            setShift(shiftState.shiftGetData);
            dispatch(initShiftState());
        }
    }, [commonStore, branchState, shiftState, dispatch]);

    useEffect(() => {
        if (commonStore.commonSuccess) {
            dispatch(initCommonState());
            getNotification();
            handleCloseAllModals();
        } else if (commonStore.commonError) {
            toast.error(commonStore.commonMessage);
            dispatch(initCommonState());
            handleCloseAllModals();
        }
    }, [commonStore, dispatch, getNotification]);

    const handleCloseAllModals = () => {
        setShow(false);
        setShow1(false);
        setApproveStatus({ notifyId: "", staffId: "", approve: "", reason: "" });
    };

    const handleTabIndex = (index) => {
        setState((prev) => ({ ...prev, userName: "", branchId: "", shiftId: "" }));
        setActiveTab(index);
        const filtered =
            index === "4"
                ? filterDescription.filter(
                    (v) => !["1", "2", "3", "4"].includes(v.referenceId)
                )
                : filterDescription.filter(
                    (v) => v.referenceId === (index + 1).toString()
                );
        setDescription(filtered);
    };

    const onChange = ({ target: { name, value } }) => {
        setState((prev) => ({ ...prev, [name]: value }));
        const filteredArray =
            activeTab === "4"
                ? filterDescription.filter(
                    (v) => !["1", "2", "3", "4"].includes(v.referenceId)
                )
                : filterDescription.filter(
                    (v) => v.referenceId === (activeTab + 1).toString()
                );
        const filteredEmployees = filteredArray.filter(
            (v) =>
                v.staffName.toLowerCase().includes(value.toLowerCase()) ||
                v.empId.toLowerCase().includes(value.toLowerCase())
        );
        setDescription(filteredEmployees);
    };

    const submitNotification = async (id, staffId, status, latLng = [], data) => {
        setSelectedLeave(data);
        setApproveStatus({ notifyId: id, staffId, approve: status, reason: "" });

        if (latLng.length) {
            setLoadingWaypoints(true);
            const ll = splitWaypoints(latLng);
            const accurateData = await getSnapToRoadsWayPoints(ll);
            if (accurateData) {
                const uniqueLatLng = getUniqueLocations(accurateData);
                setWaypoints(uniqueLatLng);
            }
            setLoadingWaypoints(false);
        } else {
            setWaypoints([]);
        }
        setShow(true);
    };

    const handleReason = ({ target: { name, value } }) =>
        setApproveStatus((prev) => ({ ...prev, [name]: value }));

    const saveApprovalStatus = () => {
        const data = {
            path: notifyApproveRequestPath,
            data: {
                notifyId: approveStatus.notifyId,
                staffId: approveStatus.staffId,
                approve: approveStatus.approve,
                reason: approveStatus.reason,
            },
        };
        dispatch(commonSaveData(data));
    };

    const editData = (data) => {
        setUserData({
            id: data.id,
            staffId: data.staff_id,
            wishMessage: data.wishMessage,
            profileImage: data.profileImage,
            staffName: data.staffName,
            employeeId: data.empId,
        });
    };

    /* ─── Avatar cell shared renderer ─── */
    const renderAvatarCell = (row) => (
        <span className="table-link d-flex align-items-center justify-content-start gap-2">
            <div
                style={{
                    width: "32px",
                    height: "32px",
                    border: "1px solid var(--border)",
                    borderRadius: "50%",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: getInitialColor(row.data.staffName),
                    color: "white",
                    fontWeight: "600",
                    fontSize: "11px",
                    flexShrink: 0,
                }}
            >
                {getInitials(row.data.staffName)}
            </div>
            <span>
                <div style={{ fontWeight: 500, fontSize: "13px", color: "var(--text-primary)" }}>
                    {getCapitalizeWord(row.data.staffName)}
                </div>
                <div style={{ fontSize: "11px", color: "var(--text-muted)", fontFamily: "var(--mono)" }}>
                    {row.data.empId}
                </div>
            </span>
        </span>
    );

    /* ─── Leave type badge ─── */
    const renderLeaveTypeBadge = (name) => {
        if (!name) return "-";
        const lower = name.toLowerCase();
        const cls = lower.includes("sick")
            ? "leave-badge leave-sick"
            : lower.includes("casual")
                ? "leave-badge leave-casual"
                : lower.includes("earned") || lower.includes("paid")
                    ? "leave-badge leave-earned"
                    : "leave-badge leave-other";
        return <span className={cls}>{name}</span>;
    };

    /* ─── Column defs: Leave ─── */
    const heading = [
        {
            headerName: "SNo",
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 60,
            pinned: "left",
            cellStyle: { color: "var(--text-muted)", fontFamily: "var(--mono)", fontSize: "12px" },
        },
        {
            headerName: "Employee",
            pinned: "left",
            width: 260,
            cellRenderer: renderAvatarCell,
        },
        {
            headerName: "Leave Type",
            width: 150,
            cellRenderer: (row) => renderLeaveTypeBadge(row.data.leave_name),
        },
        {
            headerName: "From Date",
            width: 140,
            cellStyle: { fontFamily: "var(--mono)", fontSize: "12px", color: "var(--text-secondary)" },
            cellRenderer: (row) => row.data.start_date || "-",
        },
        {
            headerName: "To Date",
            width: 140,
            cellStyle: { fontFamily: "var(--mono)", fontSize: "12px", color: "var(--text-secondary)" },
            cellRenderer: (row) => row.data.end_date || "-",
        },
        {
            headerName: "Days",
            width: 80,
            cellStyle: { fontFamily: "var(--mono)", fontSize: "12px", fontWeight: 600, color: "var(--text-primary)" },
            cellRenderer: (rowData) =>
                rowData.data.duration
                    ? `${rowData.data.duration}d`
                    : "-",
        },
       {
    headerName: "Reason",
    field: "reason",
    flex: 1,
    minWidth: 150,
    resizable: true,
    cellStyle: {
        fontSize: "12px",
        color: "var(--text-secondary)",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
    tooltipValueGetter: (params) => params.data.reason || "",
    cellRenderer: (rowData) => rowData.data.reason || "-",
},
     {
    headerName: "Action",
    field: "id",
    width: 180,        // ← fixed width
    minWidth: 180,     // ← prevent shrinking
    maxWidth: 180,     // ← prevent growing
    pinned: "right",
    cellStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        padding: "0 12px",
        overflow: "hidden",   // ← clip anything that escapes
    },
    cellRenderer: (rowData) => {
        const approvedStatus = rowData.data.approved;
        const hasPermission = HasPermission("Offsite", "approve");
        const hasPermissionReject = HasPermission("Offsite", "reject");

        if (!hasPermission && !hasPermissionReject) return "-";

        if (approvedStatus === "0") {
            return (
                <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "nowrap" }}>
                    {hasPermission && (
                        <button
                            onClick={() =>
                                submitNotification(
                                    rowData.data.id,
                                    rowData.data.staff_id,
                                    1,
                                    rowData.data.latLongData,
                                    rowData.data
                                )
                            }
                            className="approve-btn"
                        >
                            Approve
                        </button>
                    )}
                    {hasPermissionReject && (
                        <button
                            onClick={() =>
                                submitNotification(
                                    rowData.data.id,
                                    rowData.data.staff_id,
                                    2,
                                    rowData.data.latLongData,
                                    rowData.data
                                )
                            }
                            className="reject-btn"
                        >
                            Reject
                        </button>
                    )}
                </div>
            );
        }

        return (
            <div
                className="status-wrapper"
                onClick={() =>
                    submitPreNotification(
                        rowData.data.id,
                        rowData.data.staff_id,
                        approvedStatus,
                        rowData.data
                    )
                }
            >
                <div className={`approved-status ${approvedStatus === "1" ? "is-approved" : "is-rejected"}`}>
                    <div className="d-flex align-items-center gap-2">
                        {approvedStatus === "1" ? (
                            <>
                                <IoCheckmarkCircleOutline className="approved-icon" />
                                <span className="approved-text">Approved</span>
                            </>
                        ) : (
                            <>
                                <RxCrossCircled className="rejected-icon" />
                                <span className="rejected-text">Rejected</span>
                            </>
                        )}
                    </div>
                    <RiArrowDropDownLine className="status-dropdown" />
                </div>
            </div>
        );
    },
},
    ];

    /* ─── Column defs: Offsite ─── */
    const offsiteHeading = [
        {
            headerName: "SNo",
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 60,
            pinned: "left",
            cellStyle: { color: "var(--text-muted)", fontFamily: "var(--mono)", fontSize: "12px" },
        },
        {
            headerName: "Employee",
            pinned: "left",
            width: 260,
            cellRenderer: renderAvatarCell,
        },
        {
            headerName: "Leave Type",
            field: "leave_name",
            width: 150,
            cellRenderer: (rowData) => renderLeaveTypeBadge(rowData.data.leave_name),
        },
        {
            headerName: "Start Time",
            field: "start_time",
            width: 120,
            cellStyle: { fontFamily: "var(--mono)", fontSize: "12px", color: "var(--text-secondary)" },
            cellRenderer: (rowData) => rowData.data.start_time || "-",
        },
        {
            headerName: "End Time",
            field: "end_time",
            width: 120,
            cellStyle: { fontFamily: "var(--mono)", fontSize: "12px", color: "var(--text-secondary)" },
            cellRenderer: (rowData) => rowData.data.end_time || "-",
        },
        {
            headerName: "Total Hours",
            width: 100,
            cellStyle: { fontFamily: "var(--mono)", fontSize: "12px", fontWeight: 600 },
            cellRenderer: (rowData) =>
                rowData.data.duration
                    ? `${rowData.data.duration}${rowData.data.duration > 1 ? " days" : " day"}`
                    : "-",
        },
        {
            headerName: "Start Reason",
            field: "reason",
            width: 200,
            autoHeight: true,
            wrapText: true,
            resizable: true,
            cellClass: "custom-wrap-cell",
            cellStyle: { fontSize: "12px", color: "var(--text-secondary)" },
            cellRenderer: (rowData) => rowData.data.reason || "-",
        },
        {
            headerName: "End Reason",
            field: "endReason",
            width: 200,
            autoHeight: true,
            wrapText: true,
            resizable: true,
            cellClass: "custom-wrap-cell",
            cellStyle: { fontSize: "12px", color: "var(--text-secondary)" },
            cellRenderer: (rowData) => rowData.data.endReason || "-",
        },
        {
            headerName: "Action",
            field: "id",
            width: 250,
            pinned: "right",
            cellRenderer: (rowData) => {
                const approvedStatus = rowData.data.approved;
                const hasPermission = HasPermission("Offsite", "approve");
                const hasPermissionReject = HasPermission("Offsite", "reject");

                if (!hasPermission && !hasPermissionReject) return "-";

                if (approvedStatus === "0") {
                    return (
                        <div className="d-flex align-items-center justify-content-end gap-2 notify-btn-wrapper">
                            {hasPermission && (
                                <button
                                    onClick={() =>
                                        submitNotification(
                                            rowData.data.id,
                                            rowData.data.staff_id,
                                            1,
                                            rowData.data.latLongData,
                                            rowData.data
                                        )
                                    }
                                    className="approve-btn"
                                >
                                    Approve
                                </button>
                            )}
                            {hasPermissionReject && (
                                <button
                                    onClick={() =>
                                        submitNotification(
                                            rowData.data.id,
                                            rowData.data.staff_id,
                                            2,
                                            rowData.data.latLongData,
                                            rowData.data
                                        )
                                    }
                                    className="reject-btn"
                                >
                                    Reject
                                </button>
                            )}
                        </div>
                    );
                }

                return (
                    <div
                        className="status-wrapper"
                        onClick={() =>
                            submitPreNotification(
                                rowData.data.id,
                                rowData.data.staff_id,
                                approvedStatus,
                                rowData.data
                            )
                        }
                    >
                        <div className={`approved-status ${approvedStatus === "1" ? "is-approved" : "is-rejected"}`}>
                            <div className="d-flex align-items-center gap-2">
                                {approvedStatus === "1" ? (
                                    <>
                                        <IoCheckmarkCircleOutline className="approved-icon" />
                                        <span className="approved-text">Approved</span>
                                    </>
                                ) : (
                                    <>
                                        <RxCrossCircled className="rejected-icon" />
                                        <span className="rejected-text">Rejected</span>
                                    </>
                                )}
                            </div>
                            <RiArrowDropDownLine className="status-dropdown" />
                        </div>
                    </div>
                );
            },
        },
    ];

    /* ─── Column defs: Social Hub ─── */
    const heading1 = [
        {
            headerName: "SNo",
            valueGetter: (params) => params.node.rowIndex + 1,
            width: 60,
            pinned: "left",
            cellStyle: { color: "var(--text-muted)", fontFamily: "var(--mono)", fontSize: "12px" },
        },
        {
            headerName: "Employee",
            pinned: "left",
            width: 260,
            cellRenderer: renderAvatarCell,
        },
        {
            headerName: "Message",
            field: "wishMessage",
            flex: 1,
            autoHeight: true,
            wrapText: true,
            resizable: true,
            cellClass: "custom-wrap-cell",
            cellStyle: { fontSize: "13px", color: "var(--text-secondary)" },
            cellRenderer: (rowData) => rowData.data.wishMessage || "-",
        },
        {
            headerName: "Action",
            pinned: "right",
            width: 100,
            cellRenderer: (rowData) =>
                HasPermission("Notifications", "edit") ? (
                    <div className="d-flex align-items-center h-100">
                        <button
                            className="icon-btn"
                            onClick={() => editData(rowData.data)}
                            title="Edit"
                        >
                            <HiOutlinePencil style={{ fontSize: 16 }} />
                        </button>
                    </div>
                ) : (
                    "-"
                ),
        },
    ];

    const submitPreNotification = (notifyId, staffId, approved, data) => {
        setApproveStatus({ notifyId, staffId, approve: approved, reason: "" });
        setShow1(true);
        setSelectedLeave(data);
    };

    const handleApprovedStatus = ({ target: { name, value } }) =>
        setApproveStatus((prev) => ({ ...prev, [name]: value }));

    const paginationPageSize = 10;

    const clearFilter = () => {
        setState((pre) => ({ ...pre, branchId: "", shiftId: "", userName: "" }));
        getNotification();
    };

    const navigateToAddAnnouncement = () => {
        navigate("/add-announcement");
    };

    const themeClass = themeStore.theme === "dark" ? "theme-dark" : "theme-light";

    /* ─── Tab config ─── */
    const tabs = [
        { label: "Leave", count: countLeaves.Leave },
        { label: "Regularization", count: countLeaves.Regularization },
        { label: "Offsite", count: countLeaves.Offsite },
        { label: "Permission", count: countLeaves.Permission },

    ];

    // --------------------------------------------------------------------------
    return (
        <div className={themeClass}>
            {/* ── Approve / Reject Modal ── */}
            <Dialog
                open={show}
                keepMounted
                onClose={() => setShow(false)}
                maxWidth="sm"
                fullWidth
                aria-labelledby="notify-dialog-title"
                className={`notify-dialog ${themeClass}`}
            >
                <DialogTitle className="notify-dialog-title" id="notify-dialog-title">
                    <div className="dialog-title-icon">
                        <button className="close-icon" onClick={() => setShow(false)}>✕</button>
                        <span className="dialog-title-text">
                            {notificationTitle(activeTab, approveStatus.approve)}
                        </span>
                    </div>
                    {getTitleBtn(activeTab, approveStatus.approve).isButton && (
                        <button className="universal-btn" onClick={saveApprovalStatus}>
                            {getTitleBtn(activeTab, approveStatus.approve).text}
                        </button>
                    )}
                </DialogTitle>

                <DialogContent className="notify-dialog-content">
                    {/* Leave approve detail view */}
                    {approveStatus.approve == "1" && activeTab == "0" && (
                        <div className="leave-detail-view">
                            <div className="leave-detail-header">
                                <div className="leave-detail-user">
                                    <div
                                        className="leave-detail-avatar"
                                        style={{ backgroundColor: getInitialColor(selectedLeave.staffName) }}
                                    >
                                        {getInitials(selectedLeave.staffName)}
                                    </div>
                                    <div>
                                        <h3 className="leave-detail-name">
                                            {getCapitalizeWord(selectedLeave.staffName)}
                                        </h3>
                                        <span className="leave-detail-empid">{selectedLeave.empId}</span>
                                    </div>
                                </div>
                                <div className="leave-balance-row">
                                    {[
                                        { label: "Paid", color: "#FFCB3E", v1: 1, v2: 2 },
                                        { label: "Casual", color: "#FF6557", v1: 1, v2: 2 },
                                        { label: "Sick", color: "#8660F8", v1: 1, v2: 2 },
                                    ].map((item) => (
                                        <div key={item.label} className="leave-balance-item">
                                            <span className="leave-balance-label">{item.label}</span>
                                            <CircularProgress
                                                v1={item.v1}
                                                v2={item.v2}
                                                textSize="20"
                                                textColor={themeStore.theme === "light" ? "#000" : "#fff"}
                                                pathColor={item.color}
                                                trailColor="gray"
                                                strokeWidth="15"
                                                width="64px"
                                                height="64px"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>

                            <div className="leave-detail-divider" />

                            <div className="leave-detail-fields">
                                {[
                                    { label: "From Date", value: selectedLeave.start_date },
                                    { label: "To Date", value: selectedLeave.end_date },
                                    { label: "Total Days", value: selectedLeave.duration },
                                    { label: "Reason", value: selectedLeave.reason },
                                ].map((f) => (
                                    <div key={f.label} className="leave-detail-field">
                                        <span className="leave-detail-field-label">{f.label}</span>
                                        <span className="leave-detail-field-value">{f.value}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}

                    {/* Confirm approve for non-leave non-offsite tabs */}
                    {approveStatus.approve == "1" && activeTab != "0" && activeTab != "2" && (
                        <div className="confirm-approve-wrapper">
                            <div className="confirm-approve-icon">✓</div>
                            <h4 className="confirm-approve-text">Confirm Approval</h4>
                            <p className="confirm-approve-sub">Are you sure you want to approve this request?</p>
                            <div className="confirm-approve-actions">
                                <button className="btn-cancel" onClick={() => setShow(false)}>
                                    Cancel
                                </button>
                                <button className="universal-btn" onClick={saveApprovalStatus}>
                                    Yes, Approve
                                </button>
                            </div>
                        </div>
                    )}

                    {/* Reject reason input */}
                    {approveStatus.approve != "1" && (
                        <div className="reject-reason-wrapper">
                            <label className="reject-reason-label">Reason for rejection</label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="reason"
                                value={approveStatus.reason}
                                onChange={handleReason}
                                placeholder="Please provide a reason..."
                                className="universal-input-one"
                            />
                        </div>
                    )}

                    {/* Map for offsite */}
                    {activeTab === 2 && (
                        <div className="map-wrapper">
                            <Map waypoint={waypoints} />
                        </div>
                    )}
                </DialogContent>
            </Dialog>

            {/* ── Pre-Notification (status change) Modal ── */}
            <Dialog
                open={show1}
                keepMounted
                onClose={() => setShow1(false)}
                maxWidth="sm"
                fullWidth
                aria-labelledby="pre-notify-dialog-title"
                className={`notify-dialog ${themeClass}`}
            >
                <DialogTitle className="notify-dialog-title" id="pre-notify-dialog-title">
                    <div className="dialog-title-icon">
                        <button className="close-icon" onClick={() => setShow1(false)}>✕</button>
                        <span className="dialog-title-text">
                            {notificationTitle(activeTab, approveStatus.approve)}
                        </span>
                    </div>
                    <button className="universal-btn" onClick={saveApprovalStatus}>
                        {approveStatus.approve != "1" ? "Reject" : "Approve"}
                    </button>
                </DialogTitle>
                <DialogContent className="notify-dialog-content">
                    <div className="status-change-form">
                        <label className="field-label">Status</label>
                        <select
                            name="approve"
                            value={approveStatus.approve}
                            onChange={handleApprovedStatus}
                            className="universal-input-one"
                        >
                            <option value="1">Approved</option>
                            <option value="2">Rejected</option>
                        </select>

                        {approveStatus.approve != "1" && (
                            <>
                                <label className="field-label mt-3">Reason</label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    name="reason"
                                    value={approveStatus.reason}
                                    onChange={handleReason}
                                    placeholder="Please provide a reason..."
                                    className="universal-input-one"
                                />
                            </>
                        )}
                    </div>

                    {activeTab == 2 && (
                        <div className="map-wrapper">
                            <Map waypoint={waypoints} />
                        </div>
                    )}
                </DialogContent>
            </Dialog>

            {/* ── Main content ── */}
            <div className="notification-body mt-2">
                <Widgets
                    body={
                        <div className="notification-widget-inner">
                            {/* ── Tab bar ── */}
                            <div className="notif-tabs-bar">
                                {tabs.map((tab, idx) => (
                                    <button
                                        key={idx}
                                        className={`notif-tab ${activeTab === idx ? "active" : ""}`}
                                        onClick={() => handleTabIndex(idx)}
                                    >
                                        {tab.label}
                                        {tab.count > 0 && (
                                            <span className="notif-tab-badge">{tab.count}</span>
                                        )}
                                    </button>
                                ))}
                            </div>

                            {/* ── Filters ── */}
                            <div className="notification-filters">
                                <Form>
                                    <Row className="align-items-center g-2">
                                        <Col sm="4" md="3">
                                            <Form.Control
                                                name="userName"
                                                value={state.userName}
                                                placeholder="Search by name or ID…"
                                                onChange={onChange}
                                                className="universal-input-one"
                                            />
                                        </Col>
                                        <Col sm="4" md="3">
                                            <Form.Select
                                                name="branchId"
                                                value={state.branchId}
                                                onChange={onChange}
                                                className="universal-input-one"
                                            >
                                                <option value="">All branches</option>
                                                {branch.map((row, idx) => (
                                                    <option value={row.branchId} key={idx}>
                                                        {row.branch_name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col sm="4" md="3">
                                            <Form.Select
                                                name="shiftId"
                                                value={state.shiftId}
                                                onChange={onChange}
                                                className="universal-input-one"
                                            >
                                                <option value="">All shifts</option>
                                                {shift.map((row, idx) => (
                                                    <option value={row.shiftId} key={idx}>
                                                        {row.shiftName}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Col>
                                        <Col sm="4" md="3">
                                            {(state.userName || state.shiftId || state.branchId) && (
                                                <button
                                                    type="button"
                                                    className="clear-filter-btn"
                                                    onClick={clearFilter}
                                                >
                                                    <MdClear style={{ fontSize: 14 }} />
                                                    Clear filters
                                                </button>
                                            )}
                                        </Col>
                                    </Row>
                                </Form>
                            </div>

                            {/* ── Grid ── */}
                           {/* ── Grid ── */}
<div
    className="ag-theme-quartz custom-grid"
    style={{ height: "calc(100vh - 230px)", width: "100%", overflowY: "auto" }}
>
    {commonStore.commonGetLoading ? (
        <TableSkeleton />
    ) : activeTab == 4 ? (
        /* ── Social Hub: 4-column card grid ── */
        <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
            gap: "14px",
            padding: "16px 4px",
        }}>
            {(Array.isArray(description) ? description : []).map((item, idx) => (
                <div key={idx} style={{
                    background: "var(--card-bg, var(--bs-body-bg))",
                    border: "1px solid var(--border)",
                    borderRadius: "10px",
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                }}>
                    {/* Media */}
                    <div style={{
                        background: "var(--bg-secondary)",
                        aspectRatio: "16/9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "hidden",
                    }}>
                        {item.profileImage ? (
                            <img
                                src={item.profileImage}
                                alt=""
                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                            />
                        ) : (
                            <svg width="36" height="36" viewBox="0 0 24 24" fill="none"
                                stroke="var(--text-muted)" strokeWidth="1.2">
                                <rect x="3" y="3" width="18" height="18" rx="2"/>
                                <circle cx="8.5" cy="8.5" r="1.5"/>
                                <path d="M21 15l-5-5L5 21"/>
                            </svg>
                        )}
                    </div>

                    {/* Body */}
                    <div style={{ padding: "10px 12px", flex: 1 }}>
                        <div style={{
                            fontSize: "13px", fontWeight: 500,
                            color: "var(--text-primary)",
                            whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
                            marginBottom: "4px",
                        }}>
                            {item.title || item.wishMessage?.slice(0, 30) || "Announcement"}
                        </div>
                        <div style={{
                            fontSize: "11px", color: "var(--text-muted)",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                        }}>
                            {item.wishMessage || "-"}
                        </div>
                    </div>

                    {/* Reactions */}
                    <div style={{
                        display: "flex", gap: "10px", alignItems: "center",
                        padding: "6px 12px",
                        borderTop: "1px solid var(--border)",
                        fontSize: "11px", color: "var(--text-muted)",
                    }}>
                        <span>❤ {item.likes || 0}</span>
                        <span>💔 {item.dislikes || 0}</span>
                        <span>💬 {item.comments || 0}</span>
                        <span style={{ marginLeft: "auto" }}>👁 {item.views || 0}</span>
                    </div>

                    {/* Footer */}
                    <div style={{
                        display: "flex", alignItems: "center", gap: "8px",
                        padding: "8px 12px",
                        borderTop: "1px solid var(--border)",
                    }}>
                        <div style={{
                            width: "24px", height: "24px", borderRadius: "50%",
                            background: getInitialColor(item.staffName),
                            display: "flex", alignItems: "center", justifyContent: "center",
                            fontSize: "9px", fontWeight: 600, color: "#fff", flexShrink: 0,
                        }}>
                            {getInitials(item.staffName)}
                        </div>
                        <span style={{
                            fontSize: "11px", color: "var(--text-secondary)",
                            flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                        }}>
                            {getCapitalizeWord(item.staffName)}
                        </span>
                        {HasPermission("Notifications", "edit") && (
                            <button
                                className="icon-btn"
                                onClick={() => editData(item)}
                                title="Edit"
                            >
                                <HiOutlinePencil style={{ fontSize: 14 }} />
                            </button>
                        )}
                    </div>
                </div>
            ))}
        </div>
    ) : (
        <AgGridReact
            rowData={Array.isArray(description) ? description : []}
            columnDefs={activeTab == 2 ? offsiteHeading : heading}
            pagination={false}
            paginationPageSize={paginationPageSize}
            onGridReady={onGridReady}
        />
    )}
</div>

                            {/* ── Pagination ── */}

                        </div>
                    }
                />
            </div>

            {/* ── Waypoints loader ── */}
            {loadingWaypoints && (
                <div className="waypoints-loader">
                    <span className="loader-inner">
                        <Spinner animation="border" variant="light" size="md" />
                        <span>Loading map data…</span>
                    </span>
                </div>
            )}
        </div>
    );
};

export default Notification;